<template>
    <div class="h-full w-full flex flex-col">
        <TestimonialForm mode="edit" :selected-item="selectedItem" @close="$emit('close')" @updated="$emit('updated')" />
    </div>
</template>

<script>
import TestimonialForm from "./form.vue";
export default {
    name: "testimonial-edit",
    emits: ["updated"],
    components: { TestimonialForm, },
    props: ["selectedItem"],
}
</script>